import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { style } from 'typestyle';
import { ReplacementValue } from '../../../common/utilities/StringInterpolation';

export const VPC_FONT_XLARGE = 15;
export const VPC_BOLD_FONT_WEIGHT = 700;

export interface TestIdProp {
  testId?: string;
}

export interface SettingsSectionProps<T = JSX.Element> extends TestIdProp{
  readonly title: string;
  readonly description?: ReplacementValue<T> | ReplacementValue<T>[];
}

const settingsGroup = style({
  paddingBottom: TabStyles.Spacing.LargeSpace
});

const settingsGroupName = style({
  fontSize: VPC_FONT_XLARGE,
  fontWeight: VPC_BOLD_FONT_WEIGHT,
  paddingBottom: TabStyles.Spacing.MediumSpace,
  color: TabStyles.Typography.Color.PrimaryDark
});

const settingsGroupDescription = style({
  paddingBottom: TabStyles.Spacing.MediumSpace
});

const indent = style({
  paddingLeft: TabStyles.Spacing.LargeSpace
});


export const SettingsSection: React.FunctionComponent<SettingsSectionProps> = props =>
  <div className={settingsGroup} data-tb-test-id={props.testId}>
    <div className={settingsGroupName}> { props.title } </div>

    <div className={indent}>
      {
        props.description && <div className={settingsGroupDescription}>
          {props.description}
        </div>
      }
      {props.children}
    </div>
  </div>;
